/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioTiposMovimientosCV from './controladorVista/formularioTiposMovimientosCV';
import TablaTiposMovimientosCV from './controladorVista/tablaTiposMovimientosCV';
import { estadoIncial, reductor } from './reductorTiposMovimientos';

const TiposMovimientos: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTiposMovimientosCV />
        <FormularioTiposMovimientosCV />
    </ProveedorEstado>
);

export default TiposMovimientos;
